export default "__VITE_ASSET__CrRKrDrT__"